import { render, staticRenderFns } from "./Wrap.vue?vue&type=template&id=757d54ca&functional=true&"
var script = {}
import style0 from "./Wrap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports